import { SpeakerNameForm } from "./SpeakerNameForm";

export * from "./SpeakerNameForm";
export default SpeakerNameForm;
